// extracted by mini-css-extract-plugin
module.exports = {"createEditPriceModalPage":"CreateEditPriceModal_createEditPriceModalPage__ZtlsP"};